import {JsonProperty} from '../shared/decorators/json-property';

export class Items {
  commission: number;
  pip: number;
  rate: number;
  constructor() {
    this.commission = undefined;
    this.pip = undefined;
    this.rate = undefined;
  }
}

export class GroupConfig {
  @JsonProperty('group_config_id')
  id: string;
  name: string;
  @JsonProperty({name: 'data', clazz: Items})
  data: Items;
  @JsonProperty('is_organic_ib')
  is_organic_ib:string;
  constructor() {
    this.id = undefined;
    this.name = undefined;
    this.data = undefined;
    this.is_organic_ib = undefined
  }
}

export class TraderCampaign {
  id: string;
  code: string;
  description:string;
  groups: [];
  constructor() {
    this.id = undefined;
    this.code = undefined;
    this.description = undefined;
    this.groups = undefined;
  }
}

export class Group {
  @JsonProperty('group_config_id')
  id: number;
  @JsonProperty('trader_groups_id')
  tradeGroupId: number;
  @JsonProperty('ib_groups_id')
  IBGroupId: number;
  @JsonProperty('group_name')
  groupName: string;
  name: string;
  data: any;
  constructor() {
    this.id = undefined;
    this.groupName = undefined;
    this.name = undefined;
    this.data = undefined;
    this.tradeGroupId = undefined;
    this.IBGroupId = undefined;
  }
}
export class IBTradeSetting {
  @JsonProperty('user_id')
  id: number;
  email: string;
  @JsonProperty('first_name')
  firstName: string;
  @JsonProperty('last_name')
  lastName: string;
  @JsonProperty({name: 'groups_configs', clazz: Group})
  groups: Array<Group>;
  constructor() {
    this.id = undefined;
    this.email = undefined;
    this.firstName = undefined;
    this.lastName =  undefined;
    this.groups = [];
  }

  getUsername(): string {
    return this.firstName + ' ' + this.lastName;
  }
}
